import { createAction, props } from '@ngrx/store';
import { MaintenanceMode } from './../models/maintenance-mode';

export const watchMaintenanceMode = createAction('[Maintenance] Watch Maintenance Mode');
export const watchMaintenanceModeSuccess = createAction(
  '[Maintenance] Maintenance Mode Success',
  props<{ maintenanceMode: MaintenanceMode }>()
);
export const watchMaintenanceModeFailure = createAction('[Maintenance] Maintenance Mode Failure');
